import { StringBuilder_$ctor_Z721C83C5, StringBuilder__Append_Z721C83C5 } from "../fable-library.3.7.20/System.Text.js";
import { Record, Union, toString } from "../fable-library.3.7.20/Types.js";
import { ofList, FSharpMap__get_IsEmpty, empty, fold } from "../fable-library.3.7.20/Map.js";
import { Lazy, partialApply } from "../fable-library.3.7.20/Util.js";
import { tuple_type, lambda_type, unit_type, list_type, class_type, record_type, int32_type, bool_type, option_type, string_type, union_type } from "../fable-library.3.7.20/Reflection.js";
import { UTC$reflection } from "./Time.fs.js";
import { Uri } from "../fable-library.3.7.20/Uri.js";
import { reverse, empty as empty_1 } from "../fable-library.3.7.20/List.js";
import { fromContinuations } from "../fable-library.3.7.20/Async.js";
import { printf, toFail } from "../fable-library.3.7.20/String.js";
import { Parser$2, Parser_pOptional, Parser_textWhile, Parser_many1, Parser_tChar } from "./Parser.fs.js";
import { const$0027 } from "./Tools.fs.js";

export function queryString(queryParams) {
    const sbAppend = (str, sb) => StringBuilder__Append_Z721C83C5(sb, str);
    return toString(fold((tupledArg, key, value) => {
        let arg_1, f1_1, f1, f2;
        return [false, (arg_1 = (tupledArg[0] ? partialApply(1, sbAppend, ["?"]) : partialApply(1, sbAppend, ["\u0026"]))(tupledArg[1]), (f1_1 = ((f1 = partialApply(1, sbAppend, [key]), (f2 = partialApply(1, sbAppend, ["="]), (arg) => f2(f1(arg))))), sbAppend(value, f1_1(arg_1))))];
    }, [true, StringBuilder_$ctor_Z721C83C5("")], queryParams)[1]);
}

export function NO_COOKIES() {
    return empty();
}

export function NO_QUERIES() {
    return empty();
}

export function NO_HEADERS() {
    return empty();
}

export class CookieSameSite extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SameSiteLax", "SameSiteStrict", "SameSiteNone"];
    }
}

export function CookieSameSite$reflection() {
    return union_type("Svea.Dry.Http.CookieSameSite", [], CookieSameSite, () => [[], [], []]);
}

export class CookieContent extends Record {
    constructor(Value, Expires, Domain, Path, Secure, HttpOnly, MaxAge, SameSite) {
        super();
        this.Value = Value;
        this.Expires = Expires;
        this.Domain = Domain;
        this.Path = Path;
        this.Secure = Secure;
        this.HttpOnly = HttpOnly;
        this.MaxAge = MaxAge;
        this.SameSite = SameSite;
    }
}

export function CookieContent$reflection() {
    return record_type("Svea.Dry.Http.CookieContent", [], CookieContent, () => [["Value", string_type], ["Expires", option_type(UTC$reflection())], ["Domain", option_type(string_type)], ["Path", option_type(string_type)], ["Secure", bool_type], ["HttpOnly", bool_type], ["MaxAge", option_type(int32_type)], ["SameSite", CookieSameSite$reflection()]]);
}

export class RequestUrl extends Record {
    constructor(Uri, Path) {
        super();
        this.Uri = Uri;
        this.Path = Path;
    }
}

export function RequestUrl$reflection() {
    return record_type("Svea.Dry.Http.RequestUrl", [], RequestUrl, () => [["Uri", class_type("System.Uri")], ["Path", list_type(string_type)]]);
}

export class HttpResponse extends Record {
    constructor(Status, ContentType, SetCookie, Headers, ResponseWriter, AsyncResponseWriter) {
        super();
        this.Status = (Status | 0);
        this.ContentType = ContentType;
        this.SetCookie = SetCookie;
        this.Headers = Headers;
        this.ResponseWriter = ResponseWriter;
        this.AsyncResponseWriter = AsyncResponseWriter;
    }
}

export function HttpResponse$reflection() {
    return record_type("Svea.Dry.Http.HttpResponse", [], HttpResponse, () => [["Status", int32_type], ["ContentType", string_type], ["SetCookie", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, CookieContent$reflection()])], ["Headers", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["ResponseWriter", lambda_type(class_type("System.IO.Stream"), unit_type)], ["AsyncResponseWriter", lambda_type(class_type("System.IO.Stream"), class_type("System.Threading.Tasks.Task`1", [unit_type]))]]);
}

export class HttpRequest extends Record {
    constructor(Url, Proxy$, HttpMethod, ContentType, RemoteAddr, RemoteHost, HttpOrigin, HttpXForwardedFor, Referer, Headers, Cookies, QueryString, RequestStream) {
        super();
        this.Url = Url;
        this.Proxy = Proxy$;
        this.HttpMethod = HttpMethod;
        this.ContentType = ContentType;
        this.RemoteAddr = RemoteAddr;
        this.RemoteHost = RemoteHost;
        this.HttpOrigin = HttpOrigin;
        this.HttpXForwardedFor = HttpXForwardedFor;
        this.Referer = Referer;
        this.Headers = Headers;
        this.Cookies = Cookies;
        this.QueryString = QueryString;
        this.RequestStream = RequestStream;
    }
}

export function HttpRequest$reflection() {
    return record_type("Svea.Dry.Http.HttpRequest", [], HttpRequest, () => [["Url", RequestUrl$reflection()], ["Proxy", option_type(tuple_type(string_type, int32_type))], ["HttpMethod", string_type], ["ContentType", string_type], ["RemoteAddr", class_type("System.Lazy`1", [string_type])], ["RemoteHost", class_type("System.Lazy`1", [string_type])], ["HttpOrigin", class_type("System.Lazy`1", [string_type])], ["HttpXForwardedFor", class_type("System.Lazy`1", [string_type])], ["Referer", class_type("System.Uri")], ["Headers", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["Cookies", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, CookieContent$reflection()])], ["QueryString", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["RequestStream", option_type(class_type("System.IO.Stream"))]]);
}

export function createHttpRequest(uri, path, httpMethod, contentType, reqStream, cookies, query, headers) {
    return new HttpRequest(new RequestUrl(FSharpMap__get_IsEmpty(query) ? uri : Uri.create(uri, queryString(query)), path), void 0, httpMethod, contentType, new Lazy(() => ""), new Lazy(() => ""), new Lazy(() => ""), new Lazy(() => ""), Uri.create("http://localhost"), headers, cookies, query, reqStream);
}

export function POST(contentType, reqStream, headers, uri) {
    return createHttpRequest(uri, empty_1(), "POST", contentType, reqStream, NO_COOKIES(), NO_QUERIES(), headers);
}

export function PATCH(queryParams, reqStream, uri) {
    return createHttpRequest(uri, empty_1(), "PATCH", "", reqStream, NO_COOKIES(), queryParams, NO_HEADERS());
}

export function POSTwCookies(contentType, reqStream, headers, cookies, uri) {
    return createHttpRequest(uri, empty_1(), "POST", contentType, reqStream, cookies, NO_QUERIES(), headers);
}

export function PUT(contentType, reqStream, headers, uri) {
    return createHttpRequest(uri, empty_1(), "PUT", contentType, reqStream, NO_COOKIES(), NO_QUERIES(), headers);
}

export function GET(uri) {
    return createHttpRequest(uri, empty_1(), "GET", "", void 0, NO_COOKIES(), NO_QUERIES(), NO_HEADERS());
}

export function GETwQuery(queryParams, uri) {
    return createHttpRequest(uri, empty_1(), "GET", "", void 0, NO_COOKIES(), queryParams, NO_HEADERS());
}

export function GETwQueryAndCookies(queryParams, cookies, uri) {
    return createHttpRequest(uri, empty_1(), "GET", "", void 0, cookies, queryParams, NO_HEADERS());
}

export function HEAD(uri) {
    return createHttpRequest(uri, empty_1(), "HEAD", "", void 0, NO_COOKIES(), NO_QUERIES(), NO_HEADERS());
}

export function sendRequest(req) {
    return fromContinuations((tupledArg) => {
        const xhr = new XMLHttpRequest();
        xhr.open(req.HttpMethod, toString(req.Url.Uri));
        xhr.onreadystatechange = (() => {
            if (xhr.readyState === 4) {
                tupledArg[0](new HttpResponse(xhr.status, xhr.responseType, empty(), empty(), (s) => {
                }, (s_1) => toFail(printf("Not implemented"))));
            }
        });
        xhr.send();
    });
}

export const queryStringParser = (() => {
    let m1, m2, m_1, n_1, m, n;
    let input_6;
    const m_2 = Parser_tChar("?");
    const n_2 = Parser_many1((m1 = Parser_textWhile((y) => ("=" !== y)), (m2 = ((m_1 = Parser_tChar("="), (n_1 = ((m = Parser_textWhile((y_1) => ("\u0026" !== y_1)), (n = Parser_pOptional(Parser_tChar("\u0026")), new Parser$2(0, (i_2, s_1) => {
        const matchValue_1 = m.fields[0](i_2, s_1);
        if (matchValue_1 == null) {
            return void 0;
        }
        else {
            const i_1_1 = matchValue_1[1] | 0;
            return ((m$0027) => (new Parser$2(0, (i, s) => {
                const matchValue = n.fields[0](i, s);
                if (matchValue == null) {
                    return void 0;
                }
                else {
                    const i_1 = matchValue[1] | 0;
                    return [((arg10$0040) => const$0027(m$0027, arg10$0040))(matchValue[0]), i_1];
                }
            })))(matchValue_1[0]).fields[0](i_1_1, s_1);
        }
    })))), new Parser$2(0, (i_3, s_2) => {
        const matchValue_2 = m_1.fields[0](i_3, s_2);
        if (matchValue_2 == null) {
            return void 0;
        }
        else {
            const i_1_2 = matchValue_2[1] | 0;
            return ((arg10$0040_1) => const$0027(n_1, arg10$0040_1))(matchValue_2[0]).fields[0](i_1_2, s_2);
        }
    })))), new Parser$2(0, (i_5, s_4) => {
        const matchValue_4 = m1.fields[0](i_5, s_4);
        if (matchValue_4 == null) {
            return void 0;
        }
        else {
            const i_1_4 = matchValue_4[1] | 0;
            return ((x1) => (new Parser$2(0, (i_4, s_3) => {
                const matchValue_3 = m2.fields[0](i_4, s_3);
                if (matchValue_3 == null) {
                    return void 0;
                }
                else {
                    const i_1_3 = matchValue_3[1] | 0;
                    return [((y_2) => [x1, y_2])(matchValue_3[0]), i_1_3];
                }
            })))(matchValue_4[0]).fields[0](i_1_4, s_4);
        }
    }))), reverse);
    input_6 = (new Parser$2(0, (i_6, s_5) => {
        const matchValue_5 = m_2.fields[0](i_6, s_5);
        if (matchValue_5 == null) {
            return void 0;
        }
        else {
            const i_1_5 = matchValue_5[1] | 0;
            return ((arg10$0040_2) => const$0027(n_2, arg10$0040_2))(matchValue_5[0]).fields[0](i_1_5, s_5);
        }
    }));
    return new Parser$2(0, (i_7, s_6) => {
        const matchValue_6 = input_6.fields[0](i_7, s_6);
        if (matchValue_6 == null) {
            return void 0;
        }
        else {
            const i_1_6 = matchValue_6[1] | 0;
            return [(ofList)(matchValue_6[0]), i_1_6];
        }
    });
})();

export function createResponse$0027(status, contentType, responseWriter, responseWriterAsync) {
    return new HttpResponse(status, contentType, empty(), empty(), responseWriter, responseWriterAsync);
}

